export const tools = {
  readOnlyTool: 'readOnlyTool',
  interactiveTool: 'interactiveTool',
  pwTool: 'pwTool',
};

export const tableHeaders = {
  сlient: { title: 'clientEmail' },
  version: { title: 'type' },
  dateCreated: { title: 'createdAt' },
  lastModified: { title: 'updatedAt' },
  lastAccessed: { title: 'accessedAt' },
};

export const userTypes = {
  readOnly: 'JLL',
  interactive: 'Client',
};

export const EXTERNAL_ACCESS_STORAGE = 'external-access-storage';
